// Polyfills
import "@bart-krakowski/get-week-info-polyfill";
import "./index.css";
// Imports
import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./scss/index.scss";
import { enableMapSet } from "immer";
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
} from "react-router-dom";
import App from "./App";

enableMapSet();

if (
	!!import.meta.env.PUBLIC_ENV &&
	!!import.meta.env.PUBLIC_SENTRY_DNS_CLIENT
) {
	Sentry.init({
		dsn: import.meta.env.PUBLIC_SENTRY_DNS_CLIENT,
		environment: import.meta.env.PUBLIC_ENV,
		integrations: [
			Sentry.reactRouterV7BrowserTracingIntegration({
				useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			}),
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration(),
		],
		// Tracing
		tracesSampleRate: 1.0, //  Capture 100% of the transactions
		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		tracePropagationTargets: [
			"localhost",
			/^https:\/\/(app|staging)\.firestartermarketing\.ai\/api/i,
		],
		// Session Replay
		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	});
}

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement,
);
root.render(<App />);
